const githubAuthStateStorageKey = "spawning-pool:auth:github-state";

export function saveGithubAuthState(state: string): void {
  try {
    window.sessionStorage.setItem(githubAuthStateStorageKey, state);
  } catch {
    throw new Error("브라우저 세션 저장소에 GitHub 로그인 상태를 저장하지 못했습니다.");
  }
}

export function consumeGithubAuthState(): string | null {
  try {
    const state = window.sessionStorage.getItem(githubAuthStateStorageKey);
    window.sessionStorage.removeItem(githubAuthStateStorageKey);
    return state;
  } catch {
    return null;
  }
}

export function clearGithubAuthState(): void {
  try {
    window.sessionStorage.removeItem(githubAuthStateStorageKey);
  } catch {
    // 저장소가 막힌 환경에서는 지울 callback state도 없다.
  }
}
